import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    // Determine intended role from the current path
    const path = window.location.pathname;
    let intendedRole = 'student';
    if (path.startsWith('/instructor')) intendedRole = 'instructor';
    else if (path.startsWith('/community')) intendedRole = 'community';
    else if (path.startsWith('/admin')) intendedRole = 'admin';

    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session?session_id=${sessionId}&intended_role=${intendedRole}`);
        if (!res.ok) throw new Error('Auth failed');
        const data = await res.json();
        localStorage.setItem('session_token', data.session_token);
        setUser(data.user);

        // Redirect to the portal they selected.
        // NOTE: Do NOT pass `{ state: { user } }` here — React Router calls
        // history.pushState which structuredClones the state, and Firefox throws
        // "The object can not be cloned" if any nested user field isn't cloneable.
        // setUser(data.user) above already populates AuthContext for downstream pages.
        const role = data.user?.role;
        const roleMap = { admin: '/admin', instructor: '/instructor', community: '/community', student: '/student' };
        navigate(roleMap[role] || `/${intendedRole}`);
      } catch (err) {
        console.error('Auth error:', err);
        navigate('/');
      }
    };
    exchange();
    // Runs once on mount. hasProcessed ref guards against StrictMode double-invocation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#000' }}>
      <div className="text-center animate-fade-up">
        <div className="w-16 h-16 rounded-full border-2 border-white/20 border-t-white animate-spin mx-auto mb-6" />
        <p className="text-white/60 font-light tracking-widest text-sm uppercase">Authenticating</p>
      </div>
    </div>
  );
}
